<div class="flex gap-2 items-start">
  <app-image-picker
    [currentImageName]="currentImageName()"
    [currentImageUrl]="currentImageUrl()"
    (fileSelected)="fileSelected.emit($event)"
  />
  @if (currentImageName()) {
    <button
      mat-icon-button
      color="warn"
      type="button"
      [aria-label]="'generic.remove-image' | translate"
      [matTooltip]="'generic.remove-image' | translate"
      (click)="cleared.emit()"
    >
      <mat-icon>delete</mat-icon>
    </button>
  }
</div>
